export class eventSelectionMeta_pObj {
    jerseyIcon: any;
    isjerseyIconShown: boolean;
    shirtNumber: number;
    name : string;
    age_years : number;
    weight_value : string;
    horse_form : string;
    horse_jockey_name : string;
    owner_name: string;
    trainer_name: string;
    horse_status_runs: string;
    horse_status_wins: string;
    horse_status_places: string;
    horse_status_prizemoney: string;
    runner_commments:string;
    countryCode : string;
    sportName : string;
    
}